import { createContext, useContext, RefObject } from 'react';
import { Toast } from 'primereact/toast';

export const ToastContext = createContext<RefObject<Toast> | null>(null);

/** Call toast helpers from any component inside Layout. */
export const useToast = (): RefObject<Toast> => {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be used inside ToastProvider (Layout)');
  return ctx;
};
